import { Loader2 } from 'lucide-react';
import logo from '../../assets/images/logo_no_bg.png';

interface TopBarProps {
  title: string;
  subtitle: string;
  isLoading?: boolean;
}

export default function TopBar({ title, subtitle, isLoading = false }: TopBarProps) {
  return (
    <header className="bg-black shadow-lg border-b border-gray-800 relative">
      <div className="container mx-auto py-6 px-4 sm:px-6 lg:px-8 flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold text-white">{title}</h1>
          <p className="mt-2 text-gray-400">{subtitle}</p>
        </div>
        {isLoading && (
          <div className="flex items-center gap-2 text-blue-400">
            <Loader2 className="h-4 w-4 animate-spin" />
            <span>Loading data...</span>
          </div>
        )}
      </div>
      <img 
        src={logo}
        alt="Logo"
        style={{
          position: 'absolute',
          top: '40px',
          right: '20px',
          height: '50px',
          zIndex: 50
        }}
      />
    </header>
  );
}
